/* Publish by EComposer at 2025-08-04 06:31:32*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-o1e32taxioj"]=  window.__ectimmers["ecom-o1e32taxioj"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-o1e32taxioj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o1e32taxioj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ra81gtw2i8m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ra81gtw2i8m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m5vepvsbiiq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m5vepvsbiiq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z1q3czdc2h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z1q3czdc2h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uie505zz5c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uie505zz5c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-esoq0l4zbkj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-esoq0l4zbkj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rlfq988gk2f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rlfq988gk2f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hlfsq6tufoh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hlfsq6tufoh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s6x7heo1ng8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s6x7heo1ng8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6y0q8bnbse7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6y0q8bnbse7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vyf2s1x8lrc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vyf2s1x8lrc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b8ecvpx8nud').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b8ecvpx8nud', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o2q42dviob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o2q42dviob', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mn7o1k3qam').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mn7o1k3qam', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xg6hxa4ebrn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xg6hxa4ebrn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9tn3aj50nn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9tn3aj50nn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ym8ctqq50pp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ym8ctqq50pp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zdg3o1olhve').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zdg3o1olhve', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t7mxsx4o7eo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t7mxsx4o7eo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r7w03iu5pl9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r7w03iu5pl9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4vc3n76eeq3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4vc3n76eeq3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lm4cfkkbb6g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lm4cfkkbb6g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t5l2rhiufy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t5l2rhiufy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y58b85dog3b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y58b85dog3b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fggsbcq27ll').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fggsbcq27ll', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tmkwtp6qv7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tmkwtp6qv7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gllr5rgh4n5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gllr5rgh4n5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ysx2kmh39j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ysx2kmh39j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xhajnosyrd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xhajnosyrd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j9y32wbnua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j9y32wbnua', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zyn2url9wm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zyn2url9wm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-46djvm3zrrm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-46djvm3zrrm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pmdqs6uwj4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pmdqs6uwj4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uv54meqzl78').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uv54meqzl78', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fm20luzfs5e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fm20luzfs5e', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-51mehjbl1sk"]=  window.__ectimmers["ecom-51mehjbl1sk"] || {};
let e=this.$el;if(!e)return;let i=e.querySelectorAll(":scope > .tabs__wrapper > .tabs__navs > .tabs__navs--items > .tabs__nav"),t=e.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),n=this.settings.action;i.forEach((a,r)=>{n==="click"||window.screen.width<1025?a.onclick=function(){this.classList&&this.classList.contains("ecom-item-active")?(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active"))):(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),t[r].classList.add("ecom-item-active")),o()}:a.onmouseover=function(){this.classList&&this.classList.contains("ecom-item-active")?(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active"))):(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),t[r].classList.add("ecom-item-active")),o()}});function s(){let a=window.location.hash;if(a){let r=e.querySelector(`[data-target="${a}"]`);if(r){r.click();let c=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});r.dispatchEvent(c);let h=r.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,h)}}}setTimeout(()=>{s()},300);function o(){window.dispatchEvent(new window.Event("resize")),setTimeout(()=>{window.dispatchEvent(new window.Event("resize"))},500)}window.addEventListener("hashchange",s,!1)

                    });
                    
                        document.querySelectorAll('.ecom-51mehjbl1sk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-51mehjbl1sk', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lk7p1gjbg3l"]=  window.__ectimmers["ecom-lk7p1gjbg3l"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-lk7p1gjbg3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lk7p1gjbg3l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}